var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoKuna(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 40,
    viewBox: "0 0 16 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 0.827155V3.49976L8 9.89974L2.08697 5.16932V7.33388C2.08697 9.55282 3.09562 11.6515 4.82832 13.0376L6.95652 14.7402V11.3465H9.04348V14.7402L16 9.17496V15.6817C16 18.5346 14.7031 21.2329 12.4754 23.0151L9.04348 25.7606V31.4358L16 25.8706V28.5432L9.04348 34.1084V39.1726H6.95652V34.1084L3.52461 31.3629C1.29685 29.5807 1.14441e-05 26.8824 1.14441e-05 24.0295V17.5228L6.95652 23.088V17.4128L3.52461 14.6672C1.29685 12.885 1.14441e-05 10.1868 1.14441e-05 7.33388V0.827148L8 7.22714L16 0.827155ZM2.08697 21.8649V24.0295C2.08697 26.2484 3.09562 28.3471 4.82832 29.7332L6.95652 31.4358V25.7606L2.08697 21.8649ZM11.1717 21.3854L9.04348 23.088V17.4128L13.913 13.5171L13.913 15.6817C13.913 17.9006 12.9044 19.9993 11.1717 21.3854Z",
    fill: "url(#paint0_linear_25_1875)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25_1875",
    x1: 8,
    y1: 0.827148,
    x2: 8,
    y2: 39.1726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F29B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7C33"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoKuna);
export default __webpack_public_path__ + "static/media/logo-kuna.d4f93c9da89c2cf309949353dc783c5c.svg";
export { ForwardRef as ReactComponent };